import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入element 栅格
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);
Vue.config.productionTip = false

// ie 兼容 es6切换成es5
import 'babel-polyfill' 

/** 使用axios */
import axios from 'axios'
Vue.prototype.$axios = axios
.create({
 baseURL:'http://www.cninvestru.com:5081',
//  baseURL:'http://192.168.3.16:5081',
 timeout: 5000,
})
// //响应器

 
//添加响应拦截器
axios.interceptors.response.use(function(response){
  //对响应数据做些事
  console.log('111')
  console.log(response)
  return response;
},function(error){
  //请求错误时做些事
  console.log('222')
  console.log(error.response);
  return Promise.reject(error);
})


// 引入vue-quill-editor 富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

import 'lib-flexible/flexible'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js